export default __webpack_public_path__ + "static/media/rec_3.d3d1b0da.jpg";